import {
	Badge,
	Cell,
	Placeholder,
	Section,
	Spinner,
} from '@telegram-apps/telegram-ui'
import { useQuery } from '@tanstack/react-query'
import { useNavigate } from 'react-router'
import { Page } from 'shared/components/Page'
import { useMobileTrpc } from 'shared/api'
import { formatUzsAmount } from 'shared/lib/format'
import { useTranslate } from 'shared/lib/i18n'
import { ORDER_STATUS_KEYS, orderStatusBadgeMode } from '../lib/status'

export function Orders() {
	const trpc = useMobileTrpc()
	const navigate = useNavigate()
	const { t } = useTranslate()
	const {
		data: orders,
		isLoading,
		isError,
	} = useQuery(trpc.purchases.MyOrders.queryOptions())
	return (
		<Page>
			<div className='account-page p-4'>
				<div className='mb-4'>
					<h1 className='text-xl font-semibold text-foreground'>
						{t('navigation.orders')}
					</h1>
				</div>

				{isLoading && (
					<div className='flex justify-center py-12'>
						<Spinner size='l' />
					</div>
				)}

				{isError && (
					<Placeholder
						header={t('errors.loadFailed')}
						description={t('errors.tryLater')}
					/>
				)}

				{orders && orders.length === 0 && (
					<Placeholder
						header={t('pages.orders.empty')}
						description={t('pages.orders.emptyDescription')}
					/>
				)}

				{orders && orders.length > 0 && (
					<Section className='account-card'>
						{orders.map((order) => (
							<Cell
								key={order._id}
								onClick={() => navigate(`/lot/${order.lotId}`)}
								className='cursor-pointer hover:bg-black/5 dark:hover:bg-white/5'
								subtitle={t('pages.orders.subtitle', {
									items: order.lines.map((line) => line.label).join(', '),
									amount: t('common.amountUzs', {
										amount: formatUzsAmount(order.totalUzs),
									}),
								})}
								description={
									order.refundedUzs > 0
										? t('pages.orders.refunded', {
												amount: t('common.amountUzs', {
													amount: formatUzsAmount(order.refundedUzs),
												}),
											})
										: undefined
								}
								after={
									<Badge
										type='number'
										mode={orderStatusBadgeMode(order.status)}
									>
										{t(ORDER_STATUS_KEYS[order.status])}
									</Badge>
								}
							>
								{order.lotTitle}
							</Cell>
						))}
					</Section>
				)}
			</div>
		</Page>
	)
}
